<script setup lang="ts">
withDefaults(defineProps<{
  count: number
  expanded: boolean
}>(), {
  count: 0,
  expanded: false,
})

defineEmits<{
  click: []
}>()
</script>

<template>
  <button
    class="relative rounded-lg p-1.5 text-gray-500 hover:bg-gray-100"
    aria-label="Notificaciones"
    aria-haspopup="true"
    :aria-expanded="expanded"
    @click="$emit('click')"
  >
    <span class="plutto-icon plutto-icon--outlined text-xl">notifications</span>
    <span
      v-if="count > 0"
      class="absolute -right-0.5 -top-0.5 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-rose-500 px-1 text-[10px] font-bold text-white"
    >
      {{ count > 99 ? '99+' : count }}
    </span>
  </button>
</template>
